import { Box, Chip, OutlinedInput, Select } from '@mui/material'
import { TGetConsultationResponse } from 'feature/appeals/type'
import { FormControl, InputLabel, TextField } from 'ui'

import { AppealFileList } from '../../AppealFileList/AppealFileList'

import style from './ConsultationInformation.module.scss'

// данные заявки на консультации
export const ConsultationInformation = ({
  data,
}: {
  data: TGetConsultationResponse
}) => {
  const selectedProducts = data.products.map(product => product.name)

  return (
    <div className={style.fieldList}>
      {!!data.products?.length && (
        <>
          <FormControl sx={{ mt: 2, width: '100%' }} className={style.field1}>
            <InputLabel id='demo-multiple-chip-label'>Тип продукции</InputLabel>
            <Select
              labelId='demo-multiple-chip-label'
              id='demo-multiple-chip'
              multiple
              maxRows={10}
              value={selectedProducts}
              input={
                <OutlinedInput
                  id='select-multiple-chip'
                  label='Тип продукции'
                />
              }
              disabled
              renderValue={(selected: string[]) => (
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                  {selected?.map((productId: string) => {
                    const product = data.products.find(
                      item => item.name === productId,
                    )
                    return (
                      <Chip
                        key={productId}
                        label={product ? product.name : 'Unknown Product'}
                      />
                    )
                  })}
                </Box>
              )}
            />
          </FormControl>
        </>
      )}

      {data.comment && (
        <TextField
          multiline
          maxRows={10}
          inputProps={{ maxLength: 1000, autoComplete: 'off' }}
          label='Комментарий'
          disabled
          value={data.comment}
          className={style.field1}
        />
      )}

      {!!data.files?.length && <AppealFileList files={data.files} />}
    </div>
  )
}
